import { Titulo, ContainerTitulo,Container, Parrafo, ContainerLogos, LogoTech, A } from "../styles/skills";
import logoJs from "../img/js.png"
import logoHtml from "../img/html.png"
import logoCss from "../img/css.png"
import logoStyle from "../img/styled.png"
import logoReact from "../img/react.png"
import logoNode from "../img/node.png"
import logoRedux from "../img/redux.png"
import logoSequelize from "../img/sequelize.png"
import logoPosgresql from "../img/posgresql.png"
const Skills = () => {
  return (
    <Container>
      <ContainerTitulo>
        <Titulo>Habilidades y</Titulo>
        <Titulo>Experiencia</Titulo>
          <Parrafo>Tengo experiencia trabajando con tecnologías como
          JavaScript, HTML, Css, Sass, React, Node, Redux, Postgresql,
          Sequelize entre otras que he aprendido en mi carrera como lo son C y
          Java. </Parrafo>
          <Parrafo>Actualmente he creado dos proyectos web de manera individual
          aplicando todos mis conocimientos en Full Stack. También colabore como
          desarrollador Full Stack en un proyecto web Ecommerce donde se
          comercializan productos y se ofrecen servicios al cliente. </Parrafo>
          <Parrafo>Actualmente
          sigo profundizando más en las tecnologías que ya domino ya que me
          interesa ofrecer calidad en aquella empresa donde pueda aportar valor.
          Estoy en búsqueda de esa empresa que me permita brindarle lo mejor de
          mi y que a la vez me ofrezca desafíos donde pueda crecer
          profesionalmente.</Parrafo>
      </ContainerTitulo>

      <ContainerLogos>
        <A href="https://developer.mozilla.org/es/docs/Web/JavaScript" target="_blank" rel="noreferrer"><LogoTech src={logoJs}/></A>
        <A href="https://developer.mozilla.org/es/docs/Learn/HTML/Introduction_to_HTML/Document_and_website_structure" target="_blank" rel="noreferrer"><LogoTech src={logoHtml}/></A>
        <A href="https://developer.mozilla.org/es/docs/Web/CSS" target="_blank" rel="noreferrer"><LogoTech src={logoCss}/></A>
        <A href="https://styled-components.com/docs/basics" target="_blank" rel="noreferrer"><LogoTech src={logoStyle}/></A>
        <A href="https://es.reactjs.org/" target="_blank" rel="noreferrer"><LogoTech src={logoReact}/></A>
        <A href="https://nodejs.org/es/about/" target="_blank" rel="noreferrer"><LogoTech src={logoNode}/></A>
        <A href="https://es.redux.js.org/" target="_blank" rel="noreferrer"><LogoTech src={logoRedux}/></A>
        <A href="https://sequelize.org/" target="_blank" rel="noreferrer"><LogoTech src={logoSequelize}/></A>
        <A href="https://www.postgresql.org/" target="_blank" rel="noreferrer"><LogoTech src={logoPosgresql}/></A>
      </ContainerLogos>

    </Container>
  );
};

export default Skills;
